(function () {
  'use strict';

  function initInfiniteScroll() {
    const productGrid = document.getElementById('product-grid');
    const loader = document.getElementById('infinite-scroll-loader');

    if (!productGrid || !loader) {
      console.log('Infinite scroll: elements not found');
      return;
    }

    let nextUrl = productGrid.getAttribute('data-next-url');
    let loading = false;
    let finished = false;

    console.log('Infinite scroll initialized');
    console.log('Next URL:', nextUrl);

    /*
     * If there is no next page, stop.
     */
    if (!nextUrl || nextUrl === 'null' || nextUrl === 'undefined') {
      console.log('Infinite scroll: no next page');
      loader.remove();
      return;
    }

    /*
     * Show / hide loading indicator.
     */
    function showLoader() {
      loader.classList.add('loading');
    }

    function hideLoader() {
      loader.classList.remove('loading');
    }

    /*
     * Load next page.
     */
    async function loadNextPage() {

      if (loading || finished || !nextUrl) {
        return;
      }

      loading = true;

      showLoader();

      console.log('Infinite scroll: loading:', nextUrl);

      try {

        /*
         * Build Shopify URL.
         */
        const url = new URL(
          nextUrl,
          window.location.origin
        );

        /*
         * Request only the current collection section.
         */
        url.searchParams.set(
          'section_id',
          productGrid.getAttribute('data-section-id')
        );

        console.log(
          'Infinite scroll request:',
          url.toString()
        );

        const response = await fetch(
          url.toString(),
          {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          }
        );

        if (!response.ok) {
          throw new Error(
            'HTTP ' + response.status
          );
        }

        const html = await response.text();

        console.log(
          'Infinite scroll response received'
        );

        /*
         * Parse response.
         */
        const parser = new DOMParser();

        const doc = parser.parseFromString(
          html,
          'text/html'
        );

        /*
         * Find next page product grid.
         */
        const nextProductGrid =
          doc.querySelector('#product-grid');

        if (!nextProductGrid) {

          console.error(
            'Infinite scroll: #product-grid not found'
          );

          console.log(
            'Response:',
            html.substring(0, 1000)
          );

          finished = true;

          return;
        }

        /*
         * Get products.
         */
        const products =
          nextProductGrid.querySelectorAll(
            ':scope > .grid__item'
          );

        console.log(
          'Products received:',
          products.length
        );

        if (!products.length) {
          finished = true;
          return;
        }

        /*
         * Append products.
         */
        products.forEach(function (product) {

          productGrid.appendChild(
            product.cloneNode(true)
          );

        });

        /*
         * Get next URL.
         */
        const newNextUrl =
          nextProductGrid.getAttribute(
            'data-next-url'
          );

        console.log(
          'Next page:',
          newNextUrl
        );

        if (newNextUrl) {

          nextUrl = newNextUrl;

          productGrid.setAttribute(
            'data-next-url',
            newNextUrl
          );

        } else {

          finished = true;

          console.log(
            'Infinite scroll: last page reached'
          );
        }

        /*
         * Reinitialize theme components.
         */
        document.dispatchEvent(
          new CustomEvent(
            'infiniteScrollProductsLoaded',
            {
              detail: {
                products: products,
                container: productGrid
              }
            }
          )
        );

        /*
         * Shopify section event.
         */
        document.dispatchEvent(
          new CustomEvent(
            'shopify:section:load',
            {
              bubbles: true,
              detail: {
                sectionId:
                  productGrid.getAttribute(
                    'data-section-id'
                  )
              }
            }
          )
        );

      } catch (error) {

        console.error(
          'Infinite scroll error:',
          error
        );

      } finally {

        loading = false;

        hideLoader();
      }
    }


    /*
     * Intersection Observer.
     *
     * IMPORTANT:
     * The loader/sentinel must NOT use display:none.
     */
    const observer =
      new IntersectionObserver(
        function (entries) {

          entries.forEach(function (entry) {

            if (
              entry.isIntersecting &&
              !loading &&
              !finished
            ) {

              loadNextPage();

            }

          });

        },
        {
          root: null,

          /*
           * Start loading 800px before
           * the user reaches the bottom.
           */
          rootMargin: '800px 0px',

          threshold: 0
        }
      );


    observer.observe(loader);


    /*
     * Safety check.
     *
     * If the first product batch does not fill
     * the screen, automatically load another page.
     */
    setTimeout(function () {

      if (
        !finished &&
        !loading &&
        nextUrl
      ) {

        const rect =
          loader.getBoundingClientRect();

        if (
          rect.top <=
          window.innerHeight + 800
        ) {

          loadNextPage();

        }

      }

    }, 500);
  }


  /*
   * Run after DOM is ready.
   */
  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initInfiniteScroll
    );

  } else {

    initInfiniteScroll();

  }

})();